import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import ContentAssetSwitcher from "@components/WebsiteRevamp/Switchers/ContentAssetSwitcher/ContentAssetSwitcher"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"

const UnderVideoSection = (props: {data: AdvancedSideAssetModuleType}) => {
	return (
		<section>
			<Separator size={128} />
			<ContainerWrapper>
				<Typography
					content={props.data?.sectionTitle}
					variant={Variant.SectionTitle}
				/>
				<Separator />
				<ContentAssetSwitcher
					contentAssetProps={{
						withAspectRation: true,
					}}
					data={props.data}
				/>
			</ContainerWrapper>
			{/* <Separator  size={128}/> */}
		</section>
		// <section>
		// 	<ContainerWrapper>
		// 		<Separator className={styles.container} size={128}>
		// 			<ContentAssetSwitcher
		// 				contentAssetProps={{
		// 					withAspectRation: true,
		// 				}}
		// 				data={props.data}
		// 			/>
		// 			{/* <Typography
		// 				content={props.data.sectionTitle}
		// 				variant={Variant.SectionTitle}
		// 			/>
		// 			<Separator size={32} />
		// 			<Typography
		// 				content={props.data.sectionSubtitle}
		// 				size={Size.S}
		// 				variant={Variant.Description}
		// 			/> */}
		// 		</Separator>
		// 	</ContainerWrapper>
		// </section>
	)
}

export default UnderVideoSection
